// Show Gift Message Modal
$(document).on('click', '.hs-product-giftwrap label', function(){
  var giftCardChecked = $(this).closest('.hs-product-giftwrap').find('input[name="hs-product-giftwrap"]').prop('checked');
  
	console.log('giftCardChecked---->>>', giftCardChecked);
  if(giftCardChecked == true){
  	$('.subscription-gift-msg-overlay, .subscription-gift-msg').fadeIn();
  } else {
  	$('.subscription-gift-msg-overlay, .subscription-gift-msg').hide();
  }
});

$(document).on('click', '.hide-sgm-modal, .custom_btns', function(){
	$('.subscription-gift-msg-overlay, .subscription-gift-msg').fadeOut();
});


$('[data-susbcript-checkout-btn]').on('click', function(){
  console.log('hit checkout on home page');
  var thiss =  $(this);
//   if(!thiss.hasClass('custom_btn')){
//   	return false;
//   }
  
  
  var customer_id = thiss.attr("data-customer-id");
  var customer_email= thiss.attr("data-customer-email");
  
  
  var $row = thiss.closest('.hs-content-block-product');

 var gift_boxs = $row.find('.hs-product-giftwrap').find('input').prop("checked");

//   if($row.length){
    var productID = $row.find('.subscription_product_data').val();
    var sid = $row.attr('data-sid');
    var sfrequency = $row.attr('data-sfrequency');
    var sunit = $row.attr('data-sunit');
  var selling_plan_id = thiss.attr('data-selling-group');
//   }
//   else{
//     var row = $(thiss).parent('.checkout_btn').parent('.inner_li').parent('li');
//     var productID = row.find('.radio_main').find('input:checked').val();
//     var sid = row.attr('data-sid');
//     var sfrequency = row.attr('data-sfrequency');
//     var sunit = row.attr('data-sunit');
//   }
  $.ajax({
    dataType: "json",
    url: '/cart.js',
    success: function(cart){
      var itemsList = '';
      console.log('enter in succsess');

      if(cart.items.length < 1) itemsList += 'empty';
      else {
        for(var i = 0; i < cart.items.length; i ++){
          if(i > 0) itemsList += ' ';
          itemsList += cart.items[i].id+'-'+cart.items[i].quantity;
        }
      }

      document.cookie = "cartItemsBackup="+itemsList+"; expires=Thu, 18 Dec 2016 12:00:00 UTC; path=/";
      var cartNote = '';
      if(gift_boxs == true){
      cartNote = $('#CartSpecialInstructions').val();
        console.log('cartNotecartNot == >', cartNote);
      }
      $.post('/cart/clear.js').always(function(){
        console.log('terere')
        addRechargeItemToCart(productID , 1, sfrequency, sunit, sid, cartNote, customer_id, customer_email, selling_plan_id);
      });
     }
  });
	console.log('yyyy');
  return false;
});



function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }

/* ////////////////////////////////////////////////////////////////////////////
//
// Recharge
//
/////////////////////////////////////////////////////////////////////////// */

function addRechargeItemToCart (variant_id, quantity, shipping_interval_frequency, shipping_interval_unit_type, subscription_id, cartNote, customer_id, customer_email, selling_plan_id) {
  data = {
    "quantity": quantity,
    "id": variant_id,
    "properties[shipping_interval_frequency]": shipping_interval_frequency, 
    "properties[shipping_interval_unit_type]": shipping_interval_unit_type,            
    "properties[subscription_id]": subscription_id,
    "note": cartNote,    
    "selling_plan": selling_plan_id
  }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(data) {// alert(data);
      do{
        token=get_cookie('cart');
      }
      while(token == undefined);

      var myshopify_domain="";
      if( myshopify_domain == "") myshopify_domain = "llb1.myshopify.com";
      try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
      var customer_param = 'customer_id='+customer_id+'&customer_email='+customer_email
      //checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker+"&"+customer_param;
      checkout_url= "/checkout";

      console.log(checkout_url);
      
      window.location.href = checkout_url;
    }
  });
}